import React, { useState, useEffect, useRef, useMemo } from 'react';
import style from './PillAdd.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import CustomDatePicker from '../../../../../components/datepicker/CustomDatePicker';
import CustomTimePicker from '../../../../../components/datepicker/CustomTimePicker';
import { styled } from '@mui/material/styles';
import { useLocation, useNavigate } from "react-router-dom";
import TextField from '@mui/material/TextField';
import DeleteIcon from '../../../../../images/common/i_delete.svg';
import dayjs from 'dayjs';
import ToastPopup from '../../../../../components/comm/ToastPopup';
import Modal from '../../../../../components/comm/Modal';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import LinearProgress, {
    linearProgressClasses,
} from '@mui/material/LinearProgress';

import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import { getPillEraTime, getPillEraTm } from '../../../../../constants/pillEraTime';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}));

const PillAdd = () => {
    const navigate = useNavigate();
    const textTitleRef = useRef(null);

    // WebView 통신 관련 상태
    const pillNameInputRef = useRef(null);
    const scrollContainerRef = useRef(null);

    const [inputText, setInputText] = useState('');
    const [step, setStep] = useState(1);
    const [openStartDate, setOpenStartDate] = useState(false);
    const [openEndDate, setOpenEndDate] = useState(false);
    const [modalTarget, setModalTarget] = useState(null); // 'start' or 'end'
    const [open, setOpen] = useState(false);
    const [toast, setToast] = useState(false);

    const [editingIndex, setEditingIndex] = useState(null);
    const [disableBlur, setDisableBlur] = useState(false); // blur 상태 추가
    const [showInputBox, setShowInputBox] = useState(true); // step 1 진입 시 true

    const pillRefs = useRef([]); // ref 배열 초기화

    const progressRef = useRef(null);
    const startFocusRef = useRef(null);
    const endFocusRef = useRef(null);
    const timeFocusRef = useRef(null);



    //모달창
    const [modalOpen, setModalOpen] = useState(false);
    const [modalDateOpen, setModalDateOpen] = useState(false);
    const [modalFinishOpen, setModalFinishOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    // editData 조건 제거
    const [pillList, setPillList] = useState(() =>
        JSON.parse(localStorage.getItem('pillList')) || []
    );

    const [selectedTime, setSelectedTime] = useState(() =>
        localStorage.getItem('selectedTime') || ''
    );

    const [timing, setTiming] = useState(() =>
        localStorage.getItem('timing') || ''
    );

    const [startDate, setStartDate] = useState(() => {
        const saved = localStorage.getItem('startDate');
        return saved ? new Date(saved) : new Date();
    });

    const [endDate, setEndDate] = useState(() => {
        const saved = localStorage.getItem('endDate');
        return saved ? new Date(saved) : dayjs().add(6, 'day').toDate();
    });

    const [alarmAgree, setAlarmAgree] = useState(() =>
        localStorage.getItem('alarmAgree') || ''
    );

    const [alarmTime, setAlarmTime] = useState(() =>
        localStorage.getItem('alarmTime') || ''
    );

    const [time, setTime] = useState({ hour: "", minute: "" });

    const pickerInitTime = useMemo(
        () => (time.hour !== "" ? time : getPillEraTime(selectedTime)),
        [time, selectedTime]
    );

    useEffect(() => {
        if (progressRef.current) {
            progressRef.current.focus();
        }
    }, [step]);


    // localStorage 초기화 함수
    const clearLocalStorage = () => {
        localStorage.removeItem("pillList");
        localStorage.removeItem("selectedTime");
        localStorage.removeItem("timing");
        localStorage.removeItem("startDate");
        localStorage.removeItem("endDate");
        localStorage.removeItem("alarmAgree");
        localStorage.removeItem("alarmTime");
    };

    // useEffect에 키보드 감지 추가
    useEffect(() => {
        const handleResize = () => {
            const vh = window.innerHeight;
            const initialVh = window.screen.height;
            const keyboardHeight = initialVh - vh;

            if (keyboardHeight > 150) { // 키보드 있음
                const container = scrollContainerRef.current;
                if (container) {
                    container.style.maxHeight = `${vh - 200}px`; // 키보드 위까지만
                    container.style.overflowY = 'auto';
                }
            } else { // 키보드 없음
                const container = scrollContainerRef.current;
                if (container) {
                    container.style.maxHeight = 'none';
                    container.style.overflowY = 'visible';
                }
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // 모달 닫기
    const closeModal = () => {
        setModalOpen(false);
    };

    const closeModalDate = () => {
        setModalDateOpen(false);

        if (!modalTarget) return; // 대상 없으면 끝

        if (modalTarget === 'start') {
            setOpenStartDate(true);  // 시작일 바텀시트 다시 열기
        }

        if (modalTarget === 'end') {
            setOpenEndDate(true);    // 종료일 바텀시트 다시 열기
        }

        setModalTarget(null); // 초기화
    };

    const closeModalFinish = () => {
        setModalFinishOpen(false);
    };

    const handleModalConfirm = () => {
        clearLocalStorage();
        setModalOpen(false);
        navigate(-1); // 이전 페이지 이동
    };

    useEffect(() => {
        if (step === 1) {
            const timer = setTimeout(() => {
                pillNameInputRef.current?.focus();

                if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                        type: 'SHOW_KEYBOARD'
                    }));
                }
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [step]);


    const activeEnter = (e) => {
        if (e.key === "Enter" && inputText.trim()) {
            setPillList((prev) => [...prev, inputText.trim()]);
            setInputText("");

            setTimeout(() => {
                const pillBotBtn = document.querySelector(`.${style['pill-bot-btn']}`);
                if (pillBotBtn) {
                    pillBotBtn.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            }, 500);
        }
    }

    const handleDelete = (index) => {
        const newList = pillList.filter((_, i) => i !== index);
        setPillList(newList);
        localStorage.setItem('pillList', JSON.stringify(newList));
    };

    const handleTimeSelect = (e) => {
        setSelectedTime(e.target.value);
        localStorage.setItem('selectedTime', e.target.value);
    };

    const setTimingAndSave = (value) => {
        setTiming(value);
        localStorage.setItem('timing', value);
    };

    const handleStartDateChange = (date) => {
        const today = dayjs().startOf('day');
        const selected = dayjs(date).startOf('day');

        if (selected.isBefore(today)) {
            setOpenStartDate(false);
            setModalMessage('시작일을 오늘보다 과거 날짜로 선택할 수 없습니다.');
            setModalTarget('start');
            setModalDateOpen(true);
            return;
        }

        setStartDate(date);
        localStorage.setItem('startDate', date.toISOString());

        // 종료일이 이미 선택되어 있고 시작일보다 이전이면 종료일 초기화
        if (endDate && dayjs(endDate).isBefore(selected)) {
            setEndDate(null);
            localStorage.removeItem('endDate');
        }
    };

    const handleEndDateChange = (date) => {
        const today = dayjs().startOf('day');
        const selected = dayjs(date).startOf('day');
        const start = startDate ? dayjs(startDate).startOf('day') : null;

        if (selected.isBefore(today)) {
            setModalMessage('종료일을 오늘보다 과거 날짜로 선택할 수 없습니다.');
            setModalTarget('end');
            setModalDateOpen(true);
            return;
        }

        if (start && selected.isBefore(start)) {
            setModalMessage('종료일을 시작일보다 과거 날짜로 선택할 수 없습니다.');
            setModalTarget('end');
            setModalDateOpen(true);
            return;
        }

        setEndDate(date);
        localStorage.setItem('endDate', date.toISOString());
    };

    const handleAlarmAgree = (value) => {
        setAlarmAgree(value);
        localStorage.setItem('alarmAgree', value);
        if (value === "Y") setTimeout(() => setOpen(true), 100);
    };

    useEffect(() => {
        setOpen(false);
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    const handlePrev = () => {
        if (step > 1) {
            setStep((prev) => prev - 1);
        }
    };

    const handleNext = () => {
        if (step === 1) {
            // inputText가 있으면 pillList에 추가
            if (inputText.trim() && !pillList.includes(inputText.trim())) {
                const newList = [...pillList, inputText.trim()];
                setPillList(newList);
                localStorage.setItem('pillList', JSON.stringify(newList));
                setInputText(""); // 추가 후 input 초기화
            }

            setStep(2); // step2로 이동
            return;
        }
        if (step === 2 && selectedTime) setStep(3);
        else if (step === 3 && timing) setStep(4);
        else if (step === 4 && startDate && endDate) setStep(5);
        else if (step === 5) setModalFinishOpen(true);

    };



    const handleConfirmTime = (value) => {
        setTime(value);

        const hour = parseInt(value.hour, 10);
        const minute = value.minute.toString().padStart(2, '0');

        const period = hour < 12 ? '오전' : '오후';
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;

        const formattedTime = `${period} ${hour12}:${minute}`;

        setAlarmTime(formattedTime);
        localStorage.setItem('alarmTime', formattedTime);
        setOpen(false);
    };

    // 스크롤 함수 분리
    const scrollToBottom = () => {
        setTimeout(() => {
            document.documentElement.scrollTop = document.documentElement.scrollHeight;
            document.body.scrollTop = document.body.scrollHeight;
        }, 100);
    };

    // 최종 서브밋
    const handleFinalSubmit = () => {
        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");

        // 시간 계산 (HHMMSS 형식)
        let alrmSetupTm = getPillEraTm(selectedTime);

        if (alarmAgree === "Y" && alarmTime) {
            const [period, timeStr] = alarmTime.split(' ');
            const [hourStr, minuteStr] = timeStr.split(':');
            let hour = parseInt(hourStr);
            const minute = parseInt(minuteStr);

            if (period === '오후' && hour !== 12) {
                hour += 12;
            } else if (period === '오전' && hour === 12) {
                hour = 0;
            }

            alrmSetupTm = `${hour.toString().padStart(2, '0')}${minute.toString().padStart(2, '0')}00`;
        }

        // 복약 기간 문자열 생성
        const startDateStr = dayjs(startDate).format('YY.MM.DD');
        const endDateStr = dayjs(endDate).format('YY.MM.DD');
        const totalDays = dayjs(endDate).diff(dayjs(startDate), 'day') + 1;
        const tkmdcnPdCn = `${startDateStr} ~ ${endDateStr} (총 ${totalDays}일)`;

        const requestUrl = "/homecare/tkmdcn/saveCustomUserTakingMedicineInfo";

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        const requestBody = {
            usrInfoId: user?.usrInfoId,
            tkmdcnGrpCd: 'ETC',
            tkmdcnEraCd: selectedTime, // 1,2,3,4,5 중 하나
            tkmdcnMthCn: timing, // 식전30분, 식후30분, 상관없음
            tkmdcnPdCn: tkmdcnPdCn, // 25.04.22 ~ 25.05.07 (총 15일)
            tkmdcnCn: pillList.join('@,@'), // 타이레놀@,@이가탄
            totTkmdcnCo: pillList.length,
            totTkmdcnDaycnt: totalDays,
            tkmdcnEndDe: dayjs(endDate).format('YYYYMMDD'),
            alrmSetupDe: dayjs(startDate).format('YYYYMMDD'),
            alrmSetupTm: alrmSetupTm, // 093500
            alrmAt: alarmAgree === 'Y' ? '1' : '0',
        };

        console.log('API 호출 데이터:', requestBody);

        axiosApi.post(requestUrl, requestBody, requestOption)
            .then((res) => {
                const resultData = res.data;

                if (resultData.resultCode === CODE.RCV_SUCCESS) {
                    clearLocalStorage();
                    sessionStorage.setItem('showToast', 'add');
                    navigate(-1);
                } else {
                    setModalMessage('복약 추가에 실패했습니다.');
                    setModalDateOpen(true);
                }
            })
            .catch((err) => {
                console.error("복약 추가 에러:", err);
                setModalMessage('복약 추가 중 오류가 발생했습니다.');
                setModalDateOpen(true);
            });
    };

    const handleChange = (index, value) => {
        setShowInputBox(false);
        const newList = [...pillList];
        newList[index] = value;
        setPillList(newList);
        localStorage.setItem('pillList', JSON.stringify(newList));

        // 커서를 맨 뒤로 이동
        const el = pillRefs.current[index]; // pillRefs는 각 input에 ref로 연결되어 있어야 함
        if (el) {
            const length = value.length;
            requestAnimationFrame(() => {
                el.setSelectionRange(length, length);
            });
        }

    };

    const handleBlur = (e, index) => {

        setEditingIndex(null); // 포커스 벗어나면 수정모드 종료
        const value = e.target.value.trim();

        if (!value && pillList.length > 1) {
            const newList = pillList.filter((_, i) => i !== index);
            setPillList(newList);
            localStorage.setItem('pillList', JSON.stringify(newList));
        }
    };


    // blur 처리 + 버튼 클릭 중복 방지 통합
    const handlePillInputBlur = (e, index) => {

        const value = e.target.value.trim();
        if (disableBlur) return; // 버튼 클릭 중이면 blur 무시


        if (value) { // 값이 있으면 업데이트
            const newList = [...pillList, inputText.trim()];
            setPillList(newList);
            localStorage.setItem('pillList', JSON.stringify(newList));
            setInputText("");
        } else {
            // 값이 없으면 리스트에서 삭제
            if (pillList.length > 1) {
                const newList = pillList.filter((_, i) => i !== index);
                setPillList(newList);
                localStorage.setItem('pillList', JSON.stringify(newList));
            }
        }

        // pillList가 비어있거나 inputText가 있으면 절대 숨기지 않음
        if (pillList.length === 0 && !inputText) {
            setShowInputBox(true);
        } else {
            setShowInputBox(false);
        }

        //setShowInputBox(false); // 값 없으면 input 박스 숨김

        //  다시 포커스
        setTimeout(() => {
            pillNameInputRef.current?.focus();
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    type: 'SHOW_KEYBOARD'
                }));
            }
        }, 100);
    };


    return (
        <>
            <HeadSub
                title={"복약 추가"}
                onBack={() => {
                    setModalOpen(true);
                }}
            />
            <div id="sub-content" data-layout="white">
                {/* <button onClick={testWebviewCall}>{JSON.stringify(notifications, null, 2)}</button> */}
                <div className="inner-wrap">
                    <div className={style["progress-box"]}
                        aria-label={`복약 추가 진행률 전체 스텝 5에서 ${step} 번째 입니다.`}
                        tabIndex={-1}           // 포커스 가능하게
                        ref={progressRef}        // ref 생성 필요
                        aria-live="polite"       // 스크린리더가 읽게
                    >
                        <p className={style["progress-count"]} aria-hidden='true'>

                            <span>{step}</span>/<span>5</span>
                        </p>

                        <BorderLinearProgress
                            variant="determinate"
                            value={20 * step}
                            className={style['border-linear-progress']}
                            aria-hidden='true'
                        />
                    </div>

                    <strong className={style["text-title"]} ref={textTitleRef}>
                        {step === 1 && '복약할 약 이름을 입력해주세요.'}
                        {step === 2 && '복약 시간대를 선택해주세요'}
                        {step === 3 && '복약 시점을 알려주세요.'}
                        {step === 4 && '복약 기간을 선택해주세요.'}
                        {step === 5 && '복약 알림을 드릴까요?'}
                    </strong>

                    {/* 복약 추가 리스트 :: S */}
                    {step === 1 && (
                        <div className={style["push-box-lists"]} ref={scrollContainerRef}>
                            <div className='animation-2'>
                                <div className={style["pill-list"]}>
                                    <ul>
                                        {pillList.map((pill, index) => (
                                            <li
                                                key={index}
                                                className={pillList.length === 1 ? `${style['one']}` : null}
                                            >
                                                <input
                                                    ref={el => pillRefs.current[index] = el}
                                                    type="text"
                                                    value={pill}
                                                    readOnly={false}
                                                    placeholder="약 이름"
                                                    onClick={() => {
                                                        setEditingIndex(index);
                                                        setTimeout(() => {
                                                            pillRefs.current[index]?.focus();
                                                            pillRefs.current[index]?.scrollIntoView({ behavior: 'smooth', block: 'center' });

                                                            if (window.ReactNativeWebView) {
                                                                window.ReactNativeWebView.postMessage(JSON.stringify({
                                                                    type: 'SHOW_KEYBOARD'
                                                                }));
                                                            }
                                                        }, 100);
                                                    }}
                                                    onChange={(e) => handleChange(index, e.target.value)}
                                                    onBlur={(e) => handleBlur(e, index)}
                                                />
                                                {pillList.length > 1 && (
                                                    <button onClick={() => handleDelete(index)}>
                                                        <img src={DeleteIcon} alt="리스트 삭제 버튼" />
                                                    </button>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                {/* input-box는 조건부로 보여줌 */}
                                {showInputBox && (
                                    <div className={style["creat-input-box"]}>
                                        <div className="input-box" data-type="b">
                                            <input
                                                ref={pillNameInputRef}
                                                type="text"
                                                name=""
                                                id="pill-name"
                                                placeholder="약 이름"
                                                value={inputText}
                                                onChange={(e) => { setInputText(e.target.value); }}
                                                onBlur={handlePillInputBlur} // 포커스 벗어나면 자동 등록
                                                onKeyDown={activeEnter}
                                                onFocus={() => {

                                                    // 안드로이드 대응: 포커스될 때마다 스크롤
                                                    setTimeout(() => {
                                                        pillNameInputRef.current?.scrollIntoView({
                                                            behavior: 'smooth',
                                                            block: 'center'
                                                        });
                                                    }, 100);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                {pillList.length > 0 && editingIndex === null && !inputText && !showInputBox && !pillList.some(item => !item.trim()) && (
                                    <div className={style['pill-bot-btn']}>
                                        <button
                                            className="btn"
                                            data-btn-type="outline-main"
                                            data-btn-size="md"
                                            data-btn-icon="plus"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowInputBox(true); // 새로운 input 박스 표시
                                                setTimeout(() => {
                                                    pillNameInputRef.current?.focus(); // 포커스만, 스크롤은 onFocus에서

                                                    if (window.ReactNativeWebView) {
                                                        window.ReactNativeWebView.postMessage(JSON.stringify({
                                                            type: 'SHOW_KEYBOARD'
                                                        }));
                                                    }
                                                }, 300);

                                            }}
                                        >
                                            <span>약 추가</span>
                                        </button>
                                    </div>
                                )}

                            </div>
                        </div>
                    )}
                    {/* 복약 추가 리스트 :: E */}

                    {/* 복역시간대 선택 :: S */}

                    {step === 2 && (
                        <div className={style['select-list-box']}>
                            <div className='animation-2'>
                                <ul>
                                    {[
                                        { label: '아침', value: '1' },
                                        { label: '점심', value: '2' },
                                        { label: '저녁', value: '3' },
                                        { label: '취침전', value: '4' },
                                        { label: '기타(필요한 시점에 아무때나)', value: '5' }
                                    ].map((t, i) => (
                                        <li key={i}>
                                            <div className='radio-selectbox'>
                                                <input
                                                    type="radio"
                                                    id={`time-${i}`}
                                                    name="pill-time"
                                                    value={t.value}
                                                    checked={selectedTime === t.value}
                                                    onChange={handleTimeSelect}
                                                />
                                                <label htmlFor={`time-${i}`}>
                                                    <span>{t.label}</span>
                                                </label>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}

                    {/* 복역시간대 선택 :: E */}

                    {/* 복역시점 선택 :: S */}
                    {step === 3 && (
                        <div className={style['select-list-box']}>
                            <div className='animation-2'>
                                <ul>
                                    {['식전30분', '식후30분', '상관없음'].map((t, i) => (
                                        <li key={i}>
                                            <div className='radio-selectbox'>
                                                <input
                                                    type="radio"
                                                    id={`timing-${i}`}
                                                    name="timing"
                                                    value={t}
                                                    checked={timing === t}
                                                    onChange={(e) => setTimingAndSave(e.target.value)}
                                                />
                                                <label htmlFor={`timing-${i}`}>
                                                    <span>{t}</span>
                                                </label>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}
                    {/* 복역시점 선택 :: E */}

                    {/* 복역기간 선택 :: S */}
                    {step === 4 && (
                        <div className={style['select-period-box']}>
                            <div className='animation-2'>
                                <p>복약 시작일</p>
                                <div className='input-box' data-type='c' ref={startFocusRef} tabIndex={-1}>
                                    <input
                                        type="button"
                                        inputMode="none"
                                        placeholder={startDate || '25.05.22'}
                                        value={startDate ? dayjs(startDate).format('YY.MM.DD') : ''}
                                        onClick={() => {
                                            setOpenStartDate(true);
                                        }}
                                        readOnly
                                        style={{}}
                                    />
                                </div>

                                <p >복약 종료일</p>
                                <div className='input-box' data-type='c' ref={endFocusRef} tabIndex={-1}>
                                    <input
                                        type="button"
                                        inputMode="none"
                                        placeholder={endDate || '25.06.01'}
                                        value={endDate ? dayjs(endDate).format('YY.MM.DD') : ''}
                                        onClick={() => setOpenEndDate(true)}
                                        readOnly
                                    />
                                </div>
                            </div>

                            <BottomSheet
                                scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                                expandOnContentDrag={false} // 내용 드래그로 확장 방지
                                open={openStartDate}
                                onDismiss={() => {
                                    setOpenStartDate(false);
                                    // BottomSheet 닫힌 후 다음 포커스로 이동
                                    setTimeout(() => {
                                        if (startFocusRef.current) {
                                            startFocusRef.current.focus({ preventScroll: true });
                                            startFocusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                        }
                                    }, 100);
                                }}
                                snapPoints={({ minHeight }) => minHeight}
                                blocking={true}
                            >
                                <CustomDatePicker
                                    titleTxt="복약 시작일 선택"
                                    onClose={() => {
                                        setOpenStartDate(false);
                                        setTimeout(() => {
                                            if (startFocusRef.current) {
                                                startFocusRef.current.focus({ preventScroll: true });
                                                startFocusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            }
                                        }, 100);
                                    }}
                                    //onConfirm={(date) => setStartDate(date)}
                                    onConfirm={(date) => {
                                        handleStartDateChange(date);
                                        setTimeout(() => {
                                            if (startFocusRef.current) {
                                                startFocusRef.current.focus({ preventScroll: true });
                                                startFocusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            }
                                        }, 100);
                                    }}
                                />
                            </BottomSheet>

                            <BottomSheet
                                scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                                expandOnContentDrag={false} // 내용 드래그로 확장 방지
                                open={openEndDate}
                                onDismiss={() => {
                                    setOpenEndDate(false);
                                    setTimeout(() => {
                                        if (endFocusRef.current) {
                                            endFocusRef.current.focus({ preventScroll: true });
                                            endFocusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                        }
                                    }, 100);
                                }}
                                snapPoints={({ minHeight }) => minHeight}
                                blocking={true}
                            >
                                <CustomDatePicker
                                    titleTxt="복약 종료일 선택"
                                    selectedDate={endDate}
                                    onClose={() => {
                                        setOpenEndDate(false);
                                        setTimeout(() => {
                                            if (endFocusRef.current) {
                                                endFocusRef.current.focus({ preventScroll: true });
                                                endFocusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            }
                                        }, 100);
                                    }}
                                    //onConfirm={(date) => setEndDate(date)}
                                    onConfirm={(date) => {
                                        handleEndDateChange(date);
                                        setTimeout(() => {
                                            if (endFocusRef.current) {
                                                endFocusRef.current.focus({ preventScroll: true });
                                                endFocusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            }
                                        }, 100);
                                    }}
                                />
                            </BottomSheet>

                        </div>
                    )}
                    {/* 복역기간 선택 :: E */}

                    {/* 복역알림 선택 :: S */}
                    {step === 5 && (
                        <div className={style['select-time-box']}>
                            <div className='animation-2'>

                                {alarmAgree === "Y" && (
                                    <div className='animation-1'>
                                        <div className={style['input-box']}>
                                            <div className='input-box m-t-32' data-type='c' data-size="sm" ref={timeFocusRef} tabIndex={-1}>
                                                <input
                                                    type="button"
                                                    name=""
                                                    inputMode="none"
                                                    id="pill-name"
                                                    value={alarmTime}
                                                    placeholder='오후 01:30'
                                                    onClick={() => setOpen(true)}
                                                    readOnly
                                                    className={!alarmTime ? "placeholder-active" : ""}
                                                />
                                                <span className='placeholder-box'>오후 01:30</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className={style['select-list-box']}>
                                    <ul>
                                        <li>
                                            <div className='radio-selectbox'>
                                                <input
                                                    type="radio"
                                                    id="alam-select1"
                                                    name='alam-select'
                                                    value="Y"
                                                    checked={alarmAgree === "Y"}
                                                    // onChange={(e) => {
                                                    // const value = e.target.value;
                                                    //     setAlarmAgree(value);
                                                    //     setAlarmTime("");
                                                    //     if (value === "Y") {
                                                    //         setTimeout(() => setOpen(true), 100); // setTimeout으로 BottomSheet
                                                    //     }
                                                    // }}
                                                    onChange={(e) => handleAlarmAgree(e.target.value)}
                                                />
                                                <label htmlFor="alam-select1">
                                                    <span>네, 알림을 받을래요</span>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='radio-selectbox'>
                                                <input
                                                    type="radio"
                                                    id="alam-select2"
                                                    name='alam-select'
                                                    value="N"
                                                    checked={alarmAgree === "N"}
                                                    onChange={(e) => handleAlarmAgree(e.target.value)}
                                                />
                                                <label htmlFor="alam-select2">
                                                    <span>아니요, 괜찮아요</span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <BottomSheet
                                scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                                expandOnContentDrag={false} // 내용 드래그로 확장 방지
                                open={open}
                                onDismiss={() => {
                                    // onDismiss();
                                    setOpen(false);
                                    setTimeout(() => {
                                        if (timeFocusRef.current) {
                                            timeFocusRef.current.focus({ preventScroll: true });
                                            timeFocusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                        }
                                    }, 200);
                                }}
                                snapPoints={({ minHeight }) => minHeight}
                                blocking={true}
                            >
                                <CustomTimePicker
                                    onClose={() => {
                                        // onDismiss();
                                        setOpen(false);
                                        setTimeout(() => {
                                            if (timeFocusRef.current) {
                                                timeFocusRef.current.focus({ preventScroll: true });
                                                timeFocusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            }
                                        }, 200);
                                    }}
                                    onConfirm={(value) => {
                                        handleConfirmTime(value);
                                        setTimeout(() => {
                                            if (timeFocusRef.current) {
                                                timeFocusRef.current.focus({ preventScroll: true });
                                                timeFocusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            }
                                        }, 200);
                                    }}
                                    titleTxt="알림 시간 선택"
                                    initialTime={pickerInitTime}
                                />
                            </BottomSheet>

                        </div>
                    )}
                    {/* 복역알림 선택 :: E */}

                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            {step === 1 ? (
                                <div className='btn-layout' data-btn-num="1">
                                    <button className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        disabled={
                                            pillList.length === 0 ||               // 리스트가 아예 없음
                                            //inputText.trim().length === 0 ||      // 입력 중인 값이 없음
                                            pillList.some(item => !item.trim())  // 리스트에 비어있는 값 있음
                                        }
                                        onClick={handleNext}>
                                        <span>다음</span>
                                    </button>
                                </div>
                            ) : (
                                <div className='btn-layout' data-btn-num="2">
                                    <button className="btn" data-btn-type="outline-main" data-btn-size="lg" onClick={handlePrev}>
                                        <span>이전</span>
                                    </button>
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        disabled={
                                            (step === 2 && !selectedTime) ||
                                            (step === 3 && !timing) ||
                                            (step === 4 && (!startDate || !endDate)) ||
                                            (step === 5 && (!alarmAgree || (alarmAgree === "Y" && !alarmTime)))
                                        }
                                        onClick={handleNext}>
                                        <span>{step === 5 ? '추가 완료' : '다음'}</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={'복약알림이 완료되었습니다.'}
                            position="center"
                            opacity="90"
                        />
                    )}

                </div>
            </div>

            {/* 모달 */}
            <Modal isOpen={modalOpen} setIsOpen={setModalOpen}>
                <div className="modal-box" data-type="a">
                    <div className="modal-top-box">
                        <div className="title-box">
                            <p>작성을 그만하시겠어요? <br /> 작성 중이던 내용은 모두 사라집니다.</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className="btn-layout">
                            <button
                                className="btn"
                                data-btn-type="outline-main"
                                data-btn-size="md"
                                onClick={closeModal}
                            >
                                <span>아니오</span>
                            </button>
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                onClick={handleModalConfirm}
                            >
                                <span>네</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={modalDateOpen} setIsOpen={setModalDateOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>{modalMessage}</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={closeModalDate}>
                                <span>확인</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* 완료 모달  */}
            <Modal isOpen={modalFinishOpen} setIsOpen={setModalFinishOpen}>
                <div className="modal-box" data-type="a">
                    <div className="modal-top-box">
                        <div className="title-box">
                            <p>추가 완료하시겠어요?</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className="btn-layout">
                            <button
                                className="btn"
                                data-btn-type="outline-main"
                                data-btn-size="md"
                                onClick={closeModalFinish}
                            >
                                <span>아니오</span>
                            </button>
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                onClick={handleFinalSubmit}
                            >
                                <span>네</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>


        </>
    );
};

export default PillAdd;